import { Card, Divider, Grid, Text } from "@mantine/core";

import Image from "next/image";
import { useTranslation } from "next-i18next";

import Link from "next/link";

import { UsefulArticleData } from "../../../hooks/react-query/useUsefulArticlesList";
import { useColors } from "../../../hooks/colors/useColors";
import { isPhone } from "../../../constants/env";
import { isTablet } from "react-device-detect";
import { MyBadge } from "../../UI/my-badge/MyBadge";
import { ButtonLink } from "../../UI/button-link/ButtonLink";
import {
  SpecialistData,
  useSpecialistList,
} from "../../../hooks/react-query/useSpecialistList";
import { Fragment, useEffect, useState } from "react";

type InputProps = {
  data: UsefulArticleData;
};

export function UsefulArticleCard({ data }: InputProps) {
  const { title, category, image } = data;
  const { specialists, getSpecialists } = useSpecialistList();

  const [author, setAuthor] = useState<SpecialistData | undefined>();

  const { colors } = useColors();
  const { t } = useTranslation("common");

  let bodyClass = "flex flex-col justify-between h-[400px] mt-4";
  if (isPhone) bodyClass = "flex flex-col justify-between";

  function width() {
    if (isPhone) {
      return "96vw";
    } else if (isTablet) {
      return 360;
    } else {
      return "100%";
    }
  }

  useEffect(() => {
    if (specialists) {
      const specialistData = getSpecialists(specialists);
      setAuthor(
        specialistData.find(
          (specialist) => specialist.urlSlug === data.specialistUrl
        )
      );
    }
  }, [specialists, data.author]);

  return (
    <Grid.Col
      span={{ base: 12, md: 6, lg: 4 }}
      className="flex justify-center !p-0"
    >
      <Card
        shadow="sm"
        p="lg"
        radius="md"
        withBorder
        className="!p-0 m-4 hover:shadow-2xl"
        style={{
          width: width(),
        }}
      >
        {/*{data.category && (*/}
        {/*  <Link href={`/blog/categoria/${data.category}`}>*/}
        {/*    <MyBadge*/}
        {/*      size="auto"*/}
        {/*      className="absolute top-2 right-2"*/}
        {/*      color={colors.primary}*/}
        {/*      textColor="white"*/}
        {/*      textSize="0.8rem"*/}
        {/*    >*/}
        {/*      {category}*/}
        {/*    </MyBadge>*/}
        {/*  </Link>*/}
        {/*)}*/}
        <div
          className="relative max-h-[250px]"
          style={{ aspectRatio: "75/40" }}
        >
          {data.image && title && (
            <Image src={image} layout="fill" alt={title} objectFit="cover" />
          )}
        </div>
        <div className={bodyClass}>
          <div className="flex flex-col justify-center items-center h-full">
            <h2
              className="text-center font-bold p-2 lg:text-3xl !my-2"
              style={{ color: colors.primary }}
            >
              {title}
            </h2>
            <Text size="md" c="dimmed" className="text-center !p-2">
              {data.description}
            </Text>
          </div>
          <div className="flex items-center justify-center w-full mb-4">
            {/* eslint-disable-next-line react/jsx-no-undef */}
            <ButtonLink
              href={`/artigos-uteis/${data.urlSlug}`}
              color={colors.white}
              textColor={colors.secondary}
              title={t("blogReadArticle")}
              uppercase
            />
          </div>
        </div>
        {author && (
          <Fragment>
            <Divider />
            <div className="h-[36px] flex justify-center items-center">
              <Link href={`/blog/autor/${data.specialistUrl}`}>
                <Text
                  className="!text-center uppercase !text-[12px] !text-blue-700 dark:!text-blue-400"
                  c={colors.grayText}
                >
                  {author.name}
                </Text>
              </Link>
            </div>
          </Fragment>
        )}
      </Card>
    </Grid.Col>
  );
}
